import type { SegmentId } from '../model/types'
export function buildSegmentOAuthState(segment: SegmentId, native: boolean, nonce: string = crypto.randomUUID()) {
  return `${native ? 'native:' : ''}seg1:${nonce}:${segment}`
}
